export default __webpack_public_path__ + "static/media/heart-footer.cba9c1ee.svg";